define('home/mixins/withFetchingView',[
    'underscore',

    'home/views/FetchingView',
], function (
    _,

    FetchingView
) {
    'use strict';

    var withFetchingView = function () {
        this.render = _.wrap(this.render, function (_render) {
            if (this.isDoneFetching())
                return _render.apply(this, _.rest(arguments));

            var fetchingView = new FetchingView();
            this.$el.html(fetchingView.render().el);
            return this;
        });
    };

    return withFetchingView;
});



